// extracted by mini-css-extract-plugin
module.exports = {"svgLink":"index_svgLink__jcF7F","active":"index_active__2e-zW","footerLinkActive":"index_footerLinkActive__1s9-R","footerLink":"index_footerLink__23pAR"};